<div class="flex gap-large">
    <div class="flex-column gap flex-1 p-2">
        <app-text-input [form]="form" id="name" [prefix]="prefix"></app-text-input>
        <div class="flex align-content-start">
            <app-check-input [form]="form" id="active" [prefix]="prefix"></app-check-input>
        </div>
    </div>
</div>
